import React from 'react';
import Icon from '../../../components/AppIcon';
import { useNavigate } from 'react-router-dom';

const QuickActions = ({ currentLanguage }) => {
  const navigate = useNavigate();

  const content = {
    en: {
      title: "Quick Actions",
      actions: [
        {
          icon: "Calendar",
          title: "Book a Ride",
          description: "Instant booking in seconds",
          path: "/smart-booking-form",
          color: "accent"
        },
        {
          icon: "List",
          title: "View Prices",
          description: "All routes and pricing",
          path: "/route-price-list",
          color: "success"
        },
        {
          icon: "Car",
          title: "Our Services",
          description: "Explore service options",
          path: "/service-categories",
          color: "warning"
        },
        {
          icon: "Phone",
          title: "Contact Us",
          description: "Get in touch instantly",
          path: "/contact-hub",
          color: "destructive"
        }
      ]
    },
    ru: {
      title: "Быстрые Действия",
      actions: [
        {
          icon: "Calendar",
          title: "Забронировать",
          description: "Мгновенное бронирование",
          path: "/smart-booking-form",
          color: "accent"
        },
        {
          icon: "List",
          title: "Посмотреть Цены",
          description: "Все маршруты и цены",
          path: "/route-price-list",
          color: "success"
        },
        {
          icon: "Car",
          title: "Наши Услуги",
          description: "Изучите варианты услуг",
          path: "/service-categories",
          color: "warning"
        },
        {
          icon: "Phone",
          title: "Связаться с Нами",
          description: "Свяжитесь мгновенно",
          path: "/contact-hub",
          color: "destructive"
        }
      ]
    },
    th: {
      title: "การดำเนินการด่วน",
      actions: [
        {
          icon: "Calendar",
          title: "จองการเดินทาง",
          description: "จองทันทีในไม่กี่วินาที",
          path: "/smart-booking-form",
          color: "accent"
        },
        {
          icon: "List",
          title: "ดูราคา",
          description: "เส้นทางและราคาทั้งหมด",
          path: "/route-price-list",
          color: "success"
        },
        {
          icon: "Car",
          title: "บริการของเรา",
          description: "สำรวจตัวเลือกบริการ",
          path: "/service-categories",
          color: "warning"
        },
        {
          icon: "Phone",
          title: "ติดต่อเรา",
          description: "ติดต่อได้ทันที",
          path: "/contact-hub",
          color: "destructive"
        }
      ]
    },
    de: {
      title: "Schnellzugriff",
      actions: [
        {
          icon: "Calendar",
          title: "Fahrt Buchen",
          description: "Sofortige Buchung in Sekunden",
          path: "/smart-booking-form",
          color: "accent"
        },
        {
          icon: "List",
          title: "Preise Anzeigen",
          description: "Alle Routen und Preise",
          path: "/route-price-list",
          color: "success"
        },
        {
          icon: "Car",
          title: "Unsere Dienstleistungen",
          description: "Service-Optionen erkunden",
          path: "/service-categories",
          color: "warning"
        },
        {
          icon: "Phone",
          title: "Kontakt",
          description: "Sofort Kontakt aufnehmen",
          path: "/contact-hub",
          color: "destructive"
        }
      ]
    },
    fr: {
      title: "Actions Rapides",
      actions: [
        {
          icon: "Calendar",
          title: "Réserver un Trajet",
          description: "Réservation instantanée en secondes",
          path: "/smart-booking-form",
          color: "accent"
        },
        {
          icon: "List",
          title: "Voir les Prix",
          description: "Tous les itinéraires et tarifs",
          path: "/route-price-list",
          color: "success"
        },
        {
          icon: "Car",
          title: "Nos Services",
          description: "Explorer les options de service",
          path: "/service-categories",
          color: "warning"
        },
        {
          icon: "Phone",
          title: "Nous Contacter",
          description: "Contactez-nous instantanément",
          path: "/contact-hub",
          color: "destructive"
        }
      ]
    },
    zh: {
      title: "快速操作",
      actions: [
        {
          icon: "Calendar",
          title: "预订行程",
          description: "几秒钟内即时预订",
          path: "/smart-booking-form",
          color: "accent"
        },
        {
          icon: "List",
          title: "查看价格",
          description: "所有路线和价格",
          path: "/route-price-list",
          color: "success"
        },
        {
          icon: "Car",
          title: "我们的服务",
          description: "探索服务选项",
          path: "/service-categories",
          color: "warning"
        },
        {
          icon: "Phone",
          title: "联系我们",
          description: "立即联系",
          path: "/contact-hub",
          color: "destructive"
        }
      ]
    },
    es: {
      title: "Acciones Rápidas",
      actions: [
        {
          icon: "Calendar",
          title: "Reservar un Viaje",
          description: "Reserva instantánea en segundos",
          path: "/smart-booking-form",
          color: "accent"
        },
        {
          icon: "List",
          title: "Ver Precios",
          description: "Todas las rutas y precios",
          path: "/route-price-list",
          color: "success"
        },
        {
          icon: "Car",
          title: "Nuestros Servicios",
          description: "Explorar opciones de servicio",
          path: "/service-categories",
          color: "warning"
        },
        {
          icon: "Phone",
          title: "Contáctenos",
          description: "Póngase en contacto al instante",
          path: "/contact-hub",
          color: "destructive"
        }
      ]
    },
    ja: {
      title: "クイックアクション",
      actions: [
        {
          icon: "Calendar",
          title: "乗車予約",
          description: "数秒で即座に予約",
          path: "/smart-booking-form",
          color: "accent"
        },
        {
          icon: "List",
          title: "料金を見る",
          description: "すべてのルートと料金",
          path: "/route-price-list",
          color: "success"
        },
        {
          icon: "Car",
          title: "サービス",
          description: "サービスオプションを探す",
          path: "/service-categories",
          color: "warning"
        },
        {
          icon: "Phone",
          title: "お問い合わせ",
          description: "すぐにお問い合わせ",
          path: "/contact-hub",
          color: "destructive"
        }
      ]
    },
    ko: {
      title: "빠른 작업",
      actions: [
        {
          icon: "Calendar",
          title: "탑승 예약",
          description: "몇 초 만에 즉시 예약",
          path: "/smart-booking-form",
          color: "accent"
        },
        {
          icon: "List",
          title: "요금 보기",
          description: "모든 노선 및 요금",
          path: "/route-price-list",
          color: "success"
        },
        {
          icon: "Car",
          title: "서비스",
          description: "서비스 옵션 탐색",
          path: "/service-categories",
          color: "warning"
        },
        {
          icon: "Phone",
          title: "문의하기",
          description: "즉시 연락",
          path: "/contact-hub",
          color: "destructive"
        }
      ]
    }
  };

  const currentContent = content?.[currentLanguage] || content?.en;

  const colorClasses = {
    accent: "bg-accent/20 group-hover:bg-accent/30",
    success: "bg-success/20 group-hover:bg-success/30",
    warning: "bg-warning/20 group-hover:bg-warning/30",
    destructive: "bg-destructive/20 group-hover:bg-destructive/30"
  };

  const iconColors = {
    accent: "var(--color-accent)",
    success: "var(--color-success)",
    warning: "var(--color-warning)",
    destructive: "var(--color-destructive)"
  };

  return (
    <section className="py-16 sm:py-20 lg:py-24 px-4 sm:px-6 lg:px-8 bg-secondary">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-center text-foreground mb-12 sm:mb-16">
          {currentContent?.title}
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {currentContent?.actions?.map((action, index) => (
            <div
              key={index}
              onClick={() => navigate(action?.path)}
              className="morphic-card p-6 sm:p-8 hover:shadow-xl transition-all duration-300 cursor-pointer group"
            >
              <div className={`w-16 h-16 ${colorClasses?.[action?.color]} rounded-2xl flex items-center justify-center mb-6 transition-colors duration-300`}>
                <Icon name={action?.icon} size={32} color={iconColors?.[action?.color]} />
              </div>
              <h3 className="text-xl font-semibold text-foreground mb-2">
                {action?.title}
              </h3>
              <p className="text-muted-foreground">
                {action?.description}
              </p>
              <div className="mt-4 flex items-center text-accent group-hover:translate-x-2 transition-transform duration-300">
                <span className="text-sm font-medium">Go</span>
                <Icon name="ArrowRight" size={16} className="ml-1" />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default QuickActions;